"use strict";

exports.__esModule = true;
exports.CommentWordCountFields = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _Translator = require("../../Core/Translator");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); } /* eslint-disable  */
var CommentWordCountFields = exports.CommentWordCountFields = /*#__PURE__*/function (_Component) {
  function CommentWordCountFields() {
    return _Component.apply(this, arguments) || this;
  }
  _inheritsLoose(CommentWordCountFields, _Component);
  var _proto = CommentWordCountFields.prototype;
  _proto.render = function render() {
    var _this$props = this.props,
      element = _this$props.element,
      elementEditor = _this$props.elementEditor,
      path = _this$props.path;
    return /*#__PURE__*/_react["default"].createElement(_Translator.Translator, null, function (_ref) {
      var translate = _ref.translate;
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        label: translate("CommentWordCount.view.label", "View")
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: _core.Classes.HTML_SELECT
      }, /*#__PURE__*/_react["default"].createElement("select", {
        value: element.props.visualisation || "table",
        onChange: function onChange(e) {
          return elementEditor.setProp(path, "visualisation", e.target.value || undefined);
        }
      }, /*#__PURE__*/_react["default"].createElement("option", {
        value: "table"
      }, translate("CommentWordCount.view.table.label", "Table")), /*#__PURE__*/_react["default"].createElement("option", {
        value: "bar"
      }, translate("CommentWordCount.barChart.label", "Bar Chart"))))), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        label: translate("CommentWordCount.minimumMatches.label", "Minimum Matches")
      }, /*#__PURE__*/_react["default"].createElement(_core.NumericInput, {
        onValueChange: function onValueChange(value) {
          return elementEditor.setProp(path, "minMatches", value);
        },
        value: element.props.minMatches || 0
      })), /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
        label: translate("CommentWordCount.limitResults.label", "Limit results to")
      }, /*#__PURE__*/_react["default"].createElement(_core.NumericInput, {
        onValueChange: function onValueChange(value) {
          return elementEditor.setProp(path, "limitResults", value);
        },
        value: element.props.limitResults || 0
      })));
    });
  };
  return CommentWordCountFields;
}(_react.Component);